var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.$t("correspondsToAge"))+":")]),_c('br'),_vm._v(" "+_vm._s(_vm.$t("fromAndIncluding"))+": "+_vm._s(_vm.$t("XOldThisYear", { age: _vm.fromAge, year: _vm.thisYear }))),_c('br'),_vm._v(" "+_vm._s(_vm.$t("toAndIncluding"))+": "+_vm._s(_vm.$t("XOldThisYear", { age: _vm.toAge, year: _vm.thisYear }))),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }